module.exports = __webpack_public_path__ + "img/clinic.fef2d908.png";